import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './components/LoginPage';
import MaxApp from './components/MaxApp';
import Dashboard from './components/Dashboard';
import GuidesPage from './components/GuidesPage';
import ToursPage from './components/ToursPage';
import CalendarPage from './components/CalendarPage';
import CalendarUpload from './components/CalendarUpload';
import { ActGenerator } from './components/ActGenerator';
import AliasManager from './components/AliasManager';
import StatisticsPage from './components/StatisticsPage';
import Settings from './components/Settings';
import ExtraProgramsPage from './components/ExtraProgramsPage';
import PeriodsManager from './components/PeriodsManager';
import TemplateManager from './components/TemplateManager';
import TemplateGenerator from './components/TemplateGenerator';
import Help from './pages/Help';
import Summary from './components/Summary';
import AvailabilityCalendar from './components/AvailabilityCalendar';
import Distribution from './components/Distribution';
import OrdersPage from './components/OrdersPage';

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));

  if (!token) {
    return <LoginPage onLogin={(newToken) => setToken(newToken)} />;
  }

  return (
    <Router>
      <Layout onLogout={() => { localStorage.removeItem('token'); setToken(null); }}>
        <Routes>
          <Route path="/max-app" element={<MaxApp />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/tours" element={<ToursPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/upload" element={<CalendarUpload />} />
          <Route path="/calculation" element={<ActGenerator />} />
          <Route path="/aliases" element={<AliasManager />} />
          <Route path="/statistics" element={<StatisticsPage />} />
          <Route path="/statistics/full" element={<StatisticsPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/extra-programs" element={<ExtraProgramsPage />} />
          <Route path="/periods" element={<PeriodsManager />} />
          <Route path="/templates" element={<TemplateManager />} />
          <Route path="/generate-template" element={<TemplateGenerator />} />
          <Route path="/help" element={<Help />} />
          <Route path="/summary" element={<Summary />} />
          <Route path="/guide-availability" element={<AvailabilityCalendar />} />
          <Route path="/distribution" element={<Distribution />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
